import { useEffect, useState } from "react";
import { client, urlFor } from "../lib/sanity";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import "./Fastigheter.css";

export default function Fastigheter() {
  const [fastigheter, setFastigheter] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    client
      .fetch(`*[_type == "property" && sold != true && soonListing != true] | order(_createdAt desc)`)
      .then(setFastigheter)
      .catch(console.error);
  }, []);

  const mainProperties = fastigheter.slice(0, 4);

  return (
    <section id="fastigheter" className="mag-list-section">
      <div className="mag-container">

        <header className="mag-list-header">
          <span className="mag-label">{t("ourHomes")}</span>
          <h2 className="mag-list-title">{t("findHomeWhereLifeHappens")}</h2>
          <p className="mag-list-intro">{t("homeDescription")}</p>
        </header>

        <div className="mag-main-grid">
          {mainProperties.map((f, idx) => (
            <RouterLink
              key={f._id}
              to={`/fastighet/${f._id}`}
              className={`mag-card ${idx % 3 === 0 ? "featured" : ""}`}
            >
              <div className="mag-card-image-wrapper">
                {f.images?.[0] && (
                  <img
                    src={urlFor(f.images[0]).width(1200).url()}
                    alt={f.address}
                    loading="lazy"
                  />
                )}
                <div className="mag-card-overlay">
                  <span className="mag-card-city">{f.city}</span>
                </div>
                <div className="mag-status-tags">
                  {f.bidding && <span className="tag bidding">{t("bidding")}</span>}
                  {f.upcomingViewing && <span className="tag upcoming">{t("upcoming")}</span>}
                </div>
              </div>

              <div className="mag-card-content">
                <span className="mag-card-city-label">{f.city}</span>
                <h3 className="mag-card-address">{f.address}</h3>
                <div className="mag-card-details-group">
                  <span className="mag-detail">{f.rooms} {t("rooms")}</span>
                  <span className="mag-sep">/</span>
                  <span className="mag-detail">{f.livingArea} m²</span>
                  <span className="mag-sep">/</span>
                  <span className="mag-card-price">
                    {f.price?.toLocaleString("sv-SE")} SEK
                  </span>
                </div>
              </div>
            </RouterLink>
          ))}
        </div>

        <footer className="mag-list-footer">
          <RouterLink to="/alla-fastigheter" className="mag-btn-editorial">
            <span>{t("moreProperties")}</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </RouterLink>
        </footer>
      </div>
    </section> 
  ); 
}